import React, { Component } from 'react';

import "./Header.scss"

class Header extends Component {
  constructor() {
    super();
    this.shareBTN = this.shareBTN.bind(this);
    this.state = {
      isActive: 0
    }
  }
  shareBTN(action) {
    var url = "https://z.ynet.co.il/short/commerce/2018/vaseline/";
    switch (action) {
      default:
      case "facebook":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_Facebook',
          'Label': window.location.href
        });
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_WhatsApp',
          'Label': window.location.href
        });
        window.open("whatsapp://send?text=" + encodeURIComponent("גבר, יש מצב שאתה יבש? כנס ובדוק עכשיו >> " + url), "_parent");
        break;
      case "email":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'Vaseline',
          'Action': 'Share_Mail',
          'Label': window.location.href
        });
        var shareText = "גבר, יש מצב שאתה יבש? כנס ובדוק עכשיו";
        window.open("mailto:?subject=" + encodeURIComponent(window.document.title) + "&body=" + encodeURIComponent(shareText + " הקליקו >> " + url), "_parent");
        break;
      case "negishut":
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
      case "sharer":
        this.setState({
          isActive: (this.state.isActive === 1 ? 0 : 1)
        });
        break;
    }
  }
  goToLink() {
    window.open("https://shop.super-pharm.co.il/vaseline?utm_source=unilever&utm_medium=banner&utm_campaign=vaseline-men_jan2018&utm_content=ynet_content", "_new");
  }
  render() {
    const isActiveIcon = (this.state.isActive === 0 ? "" : " active");
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="rightside">
              <div onClick={() => { this.shareBTN("negishut") }} className={"share negishut " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("whatsapp") }} className={"share ws " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("email") }} className={"share email " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("facebook") }} className={"share fb " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("sharer") }} className={"share sharer " + isActiveIcon}></div>
            </div>
            <div className="leftside">
              <div className="logo"></div>
            </div>
            <div className="middlelogo">
              <div className="logo" onClick={this.goToLink}></div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js